// Curated benchmark universe for the report index selector. Each group is ONE
// checkbox in the report dialog; `names` are the identity strings a report can
// emit for that economic index - the APX-era verbose spelling AND the ICE short
// spelling, aliased so one checkbox governs both. Identity = the index display
// name, matching ReportDisplayModal's `indexKey` (name || label) and the
// backend's `index_name`. Verified against banyan_iceberg (firm btam), 2026-08.
export const BENCHMARK_INDEX_GROUPS = [
  { id: 'sp500',  label: 'S&P 500 Total Return',        names: ['S&P 500 Total Return Index'] },
  { id: 'r1000',  label: 'Russell 1000',                names: ['Russell 1000 Index'] },
  { id: 'r2000',  label: 'Russell 2000',                names: ['Russell 2000 Index'] },
  { id: 'eafe',   label: 'MSCI EAFE',                   names: ['MSCI EAFE Index'] },
  { id: 'muni13', label: 'BofA 1-3 Yr Municipal',       names: ['BofA Merrill Lynch 1-3 Yr Municipal Secs Index', 'BofA 1-3 Yr US Municipal Securities'] },
  { id: 'muni37', label: 'BofA 3-7 Yr Municipal',       names: ['BofA Merrill Lynch 3-7 Yr Municipal Secs Index', 'BofA 3-7 Yr US Municipal Securities'] },
  { id: 'muni17', label: 'BofA 1-7 Yr Municipal (Blend)', names: ['BofA Merrill Lynch 1-7 Yr Municipal Secs Blended Index', 'BofA 1-7 Yr US Municipal (Blend)'] },
  { id: 'tbill',  label: 'BofA 0-3 Mo US T-Bill',       names: ['BofA Merrill Lynch 0-3 Month US Tsy Bill Index'] },
];

export const ALL_GROUP_IDS = BENCHMARK_INDEX_GROUPS.map((g) => g.id);

// Every curated identity string. A name NOT in this set is non-curated and
// always passes the filter (fail-open) - we never suppress something the PM
// was not offered as a checkbox.
export const CURATED_INDEX_NAMES = new Set(
  BENCHMARK_INDEX_GROUPS.flatMap((g) => g.names),
);

// Expand selected group ids to the set of index names they permit.
export function allowedIndexNames(selectedGroupIds) {
  const sel = new Set(selectedGroupIds || []);
  const out = new Set();
  BENCHMARK_INDEX_GROUPS.forEach((g) => {
    if (sel.has(g.id)) g.names.forEach((n) => out.add(n));
  });
  return out;
}

// Render predicate for a single index. `selectedGroupIds` null/undefined =>
// no restriction (show all). Otherwise: a curated index shows only if its group
// is selected; a non-curated index always shows (fail-open).
export function isIndexSelected(indexName, selectedGroupIds) {
  if (selectedGroupIds == null) return true;
  if (!CURATED_INDEX_NAMES.has(indexName)) return true;
  return allowedIndexNames(selectedGroupIds).has(indexName);
}
